
import Card from "@/components/base/card/Card"
import Timestamp from "@/components/base/card/Timestamp"
import Button from "@/components/base/Button"

import { mdiPlus, mdiPencil } from "@mdi/js"

export default {
    name: "EventCard",
    components: {
        Card,
        Timestamp,
        Button,
    },
    emits: ["click", "edit"],
    props: {
        /** Event object */
        event: {
            type: Object,
            default: null,
        },
        /** Adds edit button & edit event */
        editable: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        mdiPlus,
        mdiPencil,
    }),
    computed: {
        past() {
            return this.event && new Date(this.event.start_at) < new Date()
        },
        backgroundSrc() {
            if (!this.event?.image) return ""
            return this.$getImage({
                image: this.event.image,
                preferedSize: "2",
            }).src
        },
    },
}
